/**
 * Turnstile test sitekeys and helpers.
 * @package AdvancedTrackingManager
 */

export const TEST_SITEKEYS = {
  PASS_VISIBLE: '1x00000000000000000000AA',
  FAIL_VISIBLE: '2x00000000000000000000AB',
  PASS_INVISIBLE: '1x00000000000000000000BB',
  FAIL_INVISIBLE: '2x00000000000000000000BB',
  INTERACTIVE: '3x00000000000000000000FF',
} as const;

export const FAIL_TEST_SITEKEYS: string[] = [
  TEST_SITEKEYS.FAIL_VISIBLE,
  TEST_SITEKEYS.FAIL_INVISIBLE,
];

export const isFailTestSitekey = (key: string): boolean =>
  FAIL_TEST_SITEKEYS.includes(key);

export const isTestSitekey = (key: string): boolean =>
  (Object.values(TEST_SITEKEYS) as readonly string[]).includes(key);
